<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Zmiana hasła</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    :rules="notEmptyRule"
                    v-model="oldPassword"
                    label="Stare hasło"
                    type="password"
                    class="mb-5"
                  ></v-text-field>
                  <v-text-field
                    :rules="notEmptyRule"
                    v-model="newPassword"
                    label="Nowe hasło"
                    type="password"
                    class="mb-5"
                  ></v-text-field>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error darken-1" @click="close()">
            Zamknij
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success darken-1"
            @click="change(oldPassword, newPassword)"
          >
            Zmień hasło
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axiosConf from "../axios-conf";

export default {
  props: {
    open: Boolean
  },
  data() {
    return {
      dialog: false,
      notEmptyRule: [v => !!v || "To pole jest wymagane"],
      oldPassword: null,
      newPassword: null,
      valid: false
    };
  },
  watch: {
    open(newVal) {
      this.dialog = newVal;
    }
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("close", "close");
      this.$refs.form.reset();
    },
    change(oldPassword, newPassword) {
      const data = {
        oldPassword: oldPassword,
        newPassword: newPassword
      };
      axiosConf
        .post(`change-password.json`, data, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
          }
        })
        .then(response => {
          if (response.data.status) {
            this.$emit("close", true);
          } else {
            this.$emit("close", false);
          }
        });
    }
  }
};
</script>
